import React from 'react'
import Layout from '../components/PageLayout'
import Members2 from '../components/Members2';
import Section from '../components/Section'

export default ({ pageContext }) => {

  return (
    <Layout>
      <Section
        title='Qui nage, pédale ou court ?'
        id='members'
        color='background'
      >
        <Members2 
          members={pageContext.members}
        />
      </Section>
    </Layout>
  )
}
